// extracted by mini-css-extract-plugin
export var bubble = "_3b-0";
export var container = "_3b-f";
export var contrastBorder = "_3b-g";
export var greyOut = "_3b-2";
export var initialsColor0 = "_3b-3";
export var initialsColor1 = "_3b-4";
export var initialsColor10 = "_3b-d";
export var initialsColor11 = "_3b-e";
export var initialsColor2 = "_3b-5";
export var initialsColor3 = "_3b-6";
export var initialsColor4 = "_3b-7";
export var initialsColor5 = "_3b-8";
export var initialsColor6 = "_3b-9";
export var initialsColor7 = "_3b-a";
export var initialsColor8 = "_3b-b";
export var initialsColor9 = "_3b-c";
export var initialsWrapper = "_3b-1";
export var large = "_3b-l";
export var medium = "_3b-k";
export var mediumSmall = "_3b-j";
export var mediumSmallMedium = "_3b-o";
export var micro = "_3b-h";
export var small = "_3b-i";
export var tiny = "_3b-n";
export var xTiny = "_3b-m";